import { render, staticRenderFns } from "./LiveTopTag.vue?vue&type=template&id=4b16e534&scoped=true"
import script from "./LiveTopTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveTopTag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LiveTopTag.vue?vue&type=style&index=0&id=4b16e534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16e534",
  null
  
)

export default component.exports